import { CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { CommercialAgreement } from './commercial-agreement.interface';

export class CommercialAgreementService {
   async getCommercialAgreements(query: LocationQuery) {
      return await http
         .get<PaginatedResponse<CommercialAgreement>>('/general-commercial-agreements', { params: { ...query, append: 'scopes' } })
         .then((response) => response.data);
   }

   async postCommercialAgreement(commercialAgreement: CommercialAgreement) {
      return await http.post<CommercialAgreement>('/general-commercial-agreements', commercialAgreement).then((response) => response.data);
   }

   async postCommercialAgreementsBatch(commercialAgreement: CommercialAgreement) {
      return await http
         .post<CommercialAgreement>('/general-commercial-agreements-batch', commercialAgreement)
         .then((response) => response.data);
   }

   async putCommercialAgreement(commercialAgreementId: number, commercialAgreement: CommercialAgreement) {
      return await http
         .put<CommercialAgreement>(`/general-commercial-agreements/${commercialAgreementId}`, commercialAgreement)
         .then((response) => response.data);
   }

   async deleteCommercialAgreement(commercialAgreementId: number) {
      return await http.delete(`/general-commercial-agreements/${commercialAgreementId}`).then((response) => response.data);
   }

   async getCommercialAgreement(ids: any) {
      const config: CustomAxiosRequestConfig = { params: { ...ids, append: 'scopes' }, cancelable: false };
      return await http.get(`/commercial-agreement-options`, config).then((response: any) => response.data);
   }

   async getOptionalCommercialAgreements(data: any) {
      return await http.get(`/optional-commercial-agreements`, { params: { ...data } }).then((response: any) => response.data);
   }
}
